
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Calendar, CreditCard, RefreshCw } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const SubscriptionStatus: React.FC = () => {
  const { user, isAuthenticated, checkSubscription } = useAuth();
  const [isLoading, setIsLoading] = React.useState(false);

  const refreshSubscription = async () => {
    setIsLoading(true);
    try {
      await checkSubscription();
    } finally {
      setIsLoading(false);
    }
  };

  if (!isAuthenticated || !user) {
    return null;
  }

  const isSubscribed = user.subscriptionEndDate && new Date(user.subscriptionEndDate) > new Date();
  const planNames = {
    free: "Gratuito",
    basic: "Básico",
    premium: "Premium", 
    vip: "VIP"
  };

  const getStatusBadge = () => {
    if (!isSubscribed) {
      return <Badge variant="secondary">Inativo</Badge>;
    }
    return <Badge variant="default" className="bg-green-500">Ativo</Badge>;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          Status da Assinatura
          {getStatusBadge()}
        </CardTitle>
        <CardDescription>
          Gerencie sua assinatura e formas de pagamento
        </CardDescription>
      </CardHeader>

      <CardContent className="space-y-4">
        <div className="flex items-center space-x-2">
          <CreditCard className="w-4 h-4 text-muted-foreground" />
          <span className="text-sm font-medium">Plano:</span>
          <span className="text-sm">{planNames[user.plan as keyof typeof planNames] || user.plan}</span>
        </div>

        {user.subscriptionEndDate && (
          <div className="flex items-center space-x-2">
            <Calendar className="w-4 h-4 text-muted-foreground" />
            <span className="text-sm font-medium">Válido até:</span>
            <span className="text-sm">
              {new Date(user.subscriptionEndDate).toLocaleDateString('pt-BR')}
            </span>
          </div>
        )}

        {user.billingPeriod && (
          <div className="flex items-center space-x-2">
            <RefreshCw className="w-4 h-4 text-muted-foreground" />
            <span className="text-sm font-medium">Período:</span>
            <span className="text-sm capitalize">{user.billingPeriod}</span>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-2 pt-4">
          <Button 
            variant="outline" 
            onClick={() => {
              if (!isSubscribed) {
                window.location.href = '/planos#escolha-seu-plano';
              } else {
                refreshSubscription();
              }
            }}
            disabled={isLoading}
            className="flex-1"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            {!isSubscribed ? 'Escolher Plano' : 'Atualizar Status'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default SubscriptionStatus;
